import { useEffect, useRef, type JSX, type RefObject } from 'react';
import { useIntersection } from 'react-use';

import { CalmLogo, Content, Wrapper } from './styles';

const OnboardingHeader = ({
	intersectingContent,
	staticContent,
	isSticky = false,
}: {
	staticContent: JSX.Element | null;
	intersectingContent?: JSX.Element | null;
	isSticky?: boolean;
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const bodyRef = useRef<HTMLElement>(null);

	useEffect(() => {
		bodyRef.current = document.body;
	});

	// the only change here were the types. Technically we were already passing null, so casting here until react-use fixes their types.
	const intersection = useIntersection(ref as RefObject<HTMLDivElement>, {
		// TODO: refactor this code to follow best practices
		// eslint-disable-next-line react-hooks/refs
		root: bodyRef.current,
		rootMargin: '-73px 0px 0px 0px',
	});

	return (
		<Wrapper role="banner" $isSticky={isSticky}>
			<div ref={ref}>
				<Content>
					<CalmLogo />
					{(intersectingContent ?? intersection?.isIntersecting ?? isSticky)
						? intersectingContent
						: staticContent && staticContent}
				</Content>
			</div>
		</Wrapper>
	);
};

export default OnboardingHeader;
